// extracted by mini-css-extract-plugin
module.exports = {"header_div":"academicPlansList_header_div__3olEh","buttonCustomStyles":"academicPlansList_buttonCustomStyles__3hQ4T"};